<template>
  <div class="p-3 shadow-sm rounded-sm text-sm w-full bg-alert-0 text-white my-2 text-center">
    <slot />
  </div>
</template>
